import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3StaticDatumsEdit } from "./edit";
import { E3StaticDataNew } from "./new";
import { E3StaticDatumsTable } from "./table";
export default function E3StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3StaticDatumsEdit />} />
      <Route index element={<E3StaticDatumsTable />} />
      <Route path="/new" element={<E3StaticDataNew />} />
    </Routes>
  );
}
